<template>
  <div class="vip-manage">
    <div class="top-data">
      <vipCard
        label="会员收入总金额"
        :num="(cardInfo?.amount ?? 0).toFixed(0)"
        :rate="(cardInfo?.amountRatio ?? 0).toFixed(1)"
        unit="元"
      ></vipCard>
      <vipCard
        label="订阅会员总数"
        :num="(cardInfo?.subscribeNum ?? 0).toFixed(0)"
        :rate="(cardInfo?.subscribeRatio ?? 0).toFixed(1)"
        unit="人"
      ></vipCard>
      <vipCard
        label="购买会员数"
        :num="(cardInfo?.orderNum ?? 0).toFixed(0)"
        :rate="(cardInfo?.orderRatio ?? 0).toFixed(1)"
        unit="人/次"
      ></vipCard>
      <vipCard
        label="兑换会员总数"
        :num="(cardInfo?.exchangeNum ?? 0).toFixed(0)"
        :rate="(cardInfo?.exchangeRatio ?? 0).toFixed(1)"
        unit="人/次"
      ></vipCard>
      <vipCard
        label="会员总数"
        :num="(cardInfo?.vipUserNum ?? 0).toFixed(0)"
        :rate="(cardInfo?.vipUserRatio ?? 0).toFixed(1)"
        unit="人"
      ></vipCard>
    </div>
    <div class="common-func">
      <div class="sub-title">常用功能</div>
      <div class="func-list">
        <div v-for="(item, index) in commonFunc" :key="index">
          <div class="common-func-item" @click="toPage(item.path, item.code)">
            <img :src="item.icon" alt="" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="common-func data-brief">
      <div class="data-brief-top">
        <div class="top-left">
          <span class="sub-title" style="margin-bottom: 0">数据简报</span>
          <img src="@/assets/images/vip/exclamation-circle-fill.png" alt="" />
          <div class="">
            以北京时间进行数据计算，所有统计数据截止为前一日24时，当日数据不统计
          </div>
        </div>
        <div class="right-space">
          <el-tabs type="border-card" @tab-click="handleClick" :value="curTab">
            <el-tab-pane label="日" name="日"></el-tab-pane>
            <el-tab-pane label="周" name="周"></el-tab-pane>
            <el-tab-pane label="月" name="月"></el-tab-pane>
          </el-tabs>
          <el-date-picker
            v-model="dataVal"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
            value-format="yyyy-MM-dd"
            @change="handleDateChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="">
        <briefBoard :data="briefBoardData"></briefBoard>
      </div>
    </div>
  </div>
</template>

<script>
import vipCard from "./components/vipDataCard.vue";
import briefBoard from "./components/briefBoard.vue";
export default {
  components: {
    vipCard,
    briefBoard,
  },
  data() {
    return {
      commonFunc: [
        {
          name: "会员列表",
          path: "/vipList",
          code: "vip_list",
          icon: require("@/assets/images/vip/icon_viplist@2x.png"),
        },
        {
          name: "订阅记录",
          path: "/subscribeRecords",
          code: "subscribe_records",
          icon: require("@/assets/images/vip/icon_vipsubrecord@2x.png"),
        },
        {
          name: "支付记录",
          path: "/paymentRecords",
          code: "payment_records",
          icon: require("@/assets/images/vip/icon_payrecord@2x.png"),
        },
        {
          name: "兑换记录",
          path: "/exchangeRecords",
          code: "exchange_records",
          icon: require("@/assets/images/vip/icon_redeemrecord@2x.png"),
        },
        {
          name: "领取记录",
          path: "/collectionRecords",
          code: "collection_records",
          icon: require("@/assets/images/vip/icon_obtainingrecord@2x.png"),
        },
        {
          name: "兑换码管理",
          path: "/redeem",
          code: "redeem_manage",
          icon: require("@/assets/images/vip/icon_redeencodemanagement@2x.png"),
        },
        {
          name: "发送兑换码",
          path: "/redeemEmail",
          code: "redeem_email",
          icon: require("@/assets/images/vip/icon_sendredeem@2x.png"),
        },
        {
          name: "权益中心",
          path: "/equityCenter",
          code: "equity_center",
          icon: require("@/assets/images/vip/icon_rightscenter@2x.png"),
        },
        {
          name: "会员配置",
          path: "/vipConfiguration",
          code: "vip_configuration",
          icon: require("@/assets/images/vip/icon_vipconfiguration@2x.png"),
        },
      ],
      dataVal: "",
      cardInfo: {
        amount: 0,
        amountRatio: 0,
        exchangeNum: 0,
        exchangeRatio: 0,
        orderNum: 0,
        orderRatio: 0,
        subscribeNum: 0,
        subscribeRatio: 0,
        vipUserNum: 0,
        vipUserRatio: 0,
      },
      briefBoardData: {},
      time: "",
      type: 1,
      curTab: "日",
    };
  },
  async created() {
    await this.getBriefing();
    await this.getBriefBoardData();
  },
  methods: {
    toPage(path, code) {
      if (this.$jumpPerm(code)) {
        this.$router.push(path);
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    handleClick(tab) {
      this.type = tab.label === "日" ? 1 : tab.label === "周" ? 2 : 3;
      this.time = "";
      this.dataVal = "";
      this.getBriefBoardData();
    },
    handleDateChange(dates) {
      if (dates && dates.length) {
        const regTime = `${dates[0]} 00:00:00` + "~" + `${dates[1]} 23:59:59`;
        this.time = regTime;
      } else {
        this.time = "";
      }
      this.type = 1;
      this.curTab = "";
      this.getBriefBoardData();
    },
    getBriefing() {
      this.$get("/vip/data/statistics").then((res) => {
        if (res.data.code === 1000) {
          this.cardInfo = res.data.data || {};
        }
      });
    },
    getBriefBoardData() {
      this.$get("/vip/data/briefing", {
        time: this.time,
        type: this.type,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.briefBoardData = res.data.data || {};
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.vip-manage {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.top-data {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.common-func {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 16px 20px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-bottom: 20px;
}
.sub-title {
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
  margin-bottom: 20px;
}
.func-list {
  display: flex;
  justify-content: space-between;
  padding: 0 43px;
  box-sizing: border-box;
  margin-bottom: 8px;
}
.common-func-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
  img {
    width: 32px;
    height: 32px;
    margin-bottom: 8px;
  }
}
.data-brief {
  margin-bottom: 0;
  // flex-grow: 1;
}
.data-brief-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}
.top-left {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #86909c;
  img {
    width: 16px;
    height: 16px;
    margin: 0 4px 0 6px;
  }
}
.right-space {
  display: flex;
  align-items: center;
  gap: 16px;
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
::v-deep .el-tabs__item {
  height: 26px;
  line-height: 26px;
  padding: 0 12px !important;
}
::v-deep .el-tabs--border-card {
  box-shadow: none;
}
</style>
